export const CountAdapterGifts = (data) =>{
    let newData

    if(data){
        let products
        if(data?.length >= 1){
            const giftsArray = data.map(gifts => gifts?.products.map(product => product)?.length )
            products = giftsArray.reduce((acumulador, valorActual) => acumulador + valorActual, 0);
        }else{
            products = data
        }
        newData = products
    }
        // console.log('data: ', data)
        // console.log('newData: ', newData)

    return newData
}